<template>
  <v-footer dark padless>
    <v-card flat tile style="padding-top: 1%" class="secondary white--text text-center">
      <v-card-text class="white--text pt-0">
        <b>"Inovação é o que diferencia um líder de um seguidor"</b> - Steve Jobs
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        © 2021 ATCorp Software House. Todos os direitos reservados. All rights reserved.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {};
</script>
